import type { ActionReducerMap } from '@ngrx/store';
import type { RootState } from 'app/store/root/root.state';
import { rootCouriersReducer } from 'app/store/root/couriers/couriers.reducer';
import { documentsReducer } from 'app/store/root/documents/documents.reducer';
import { projectsReducer } from 'app/store/root/projects/projects.reducer';
import { simpleExtensionsReducer } from 'app/store/root/simple-extensions/simple-extensions.reducer';
import { usersReducer } from 'app/store/root/users/users.reducer';
import { webhooksReducer } from 'app/store/root/webhooks/webhooks.reducer';

export const rootReducer: ActionReducerMap<RootState, any> = {
  projects: projectsReducer,
  users: usersReducer,
  documents: documentsReducer,
  webhooks: webhooksReducer,
  couriers: rootCouriersReducer,
  simpleExtensions: simpleExtensionsReducer,
};
